export default __webpack_public_path__ + "static/media/gmc.562e75e0.png";